export default "/images/5a52b557308b4d4361be8d275eb79b79.avif";